import moment, { Moment } from 'moment';
import 'moment/locale/fr';

import { getCountry, getLanguage } from '@utils/config';
import { getEnvironment, PROD } from '@config/getEnviroment';

const calculateExpirationTime = (validSeconds: string): number => Date.now() + parseInt(validSeconds, 10) * 1000 - 10;
const isExpired = (limit: string): boolean => Date.now() >= parseInt(limit, 10);

const getCodeLanguageCountry = (): string => {
  return `${getLanguage().toLowerCase()}//${getCountry().toLowerCase()}`;
};

const parseToLongDate = (inputDate: string, separator: string = ' ') => {
  const formatWithSeparator = `D${separator}MMMM${separator}YYYY`;
  const date = moment(inputDate);
  date.locale(getCodeLanguageCountry());
  return date.format(formatWithSeparator).replace(/\b\w/g, (l) => l.toUpperCase());
};

const parseDate = (inputDate: string) => {
  const formatWithSeparator = `DD/MM/YYYY`;
  const date = moment(inputDate);
  return date.format(formatWithSeparator);
};
const isSameDay = (inputDate?: string | null) => {
  if (!inputDate) return false;
  const date = moment(parseInt(inputDate, 10));
  return moment(Date.now()).isSame(date, 'day');
};
const parseDateQuery = (inputDate: string) => {
  const formatInput = `DD/MM/YYYY`;
  const date = moment(inputDate, formatInput);
  const formatWithSeparator = `YYYY-MM-DD`;
  if (date.isValid()) {
    return date.format(formatWithSeparator);
  }
  return null;
};
const getDate = (inputDate: string, formatInput: string) => {
  return moment(inputDate, formatInput);
};
const formatDate = (input: Date) => {
  return `${input.getDate()}/${input.getMonth() + 1}/${input.getFullYear()}`;
};

const getIsoDateWithTime = (inputDate: Moment): string => {
  return `${inputDate.format('YYYY-MM-DD')}T00:00:00+0000`;
};

const getRedemptionIsoDate = (inputDate: Moment) => {
  const now = moment().utc().format('YYYY-MM-DD');
  const isTheSameDay = inputDate.isSame(now, 'day');

  return isTheSameDay ? moment().utc().format() : `${inputDate.format('YYYY-MM-DD')}T00:00:00+0000`;
};

const getDiffDaysBetweenDateAndToday = (date: string): number => {
  const today: moment.Moment = moment().endOf('day');
  const propDate: moment.Moment = moment(date).endOf('day');

  return propDate.diff(today, 'days');
};

const getFullSpelledDate = (date: string): string => {
  return moment(date).locale('fr').format('dddd D MMMM');
};

const parseRequestNodeFromObject = (object: any) => {
  const { requestDate } = object;
  const { date } = requestDate;

  return {
    ...object,
    requestDate: moment.utc(date).local().format('YYYY-MM-DD'),
  };
};

const parseExpirationNodeFromObject = (object: any) => {
  const { expirationDate } = object;
  const { date } = expirationDate;

  return {
    ...object,
    expirationDate: moment.utc(date).local().format('YYYY-MM-DD'),
  };
};

const mustRedirectIfInCampaign = () => {
  const env = getEnvironment();
  const today = moment();
  const dateSince = env === PROD ? moment('2024-12-09 00:00:00') : moment('2024-12-05 00:00:00');
  const dateUntil = moment('2024-12-16 00:00:00');

  return today.isBetween(dateSince, dateUntil);
};

const isFutureDate = (date: string) => {
  const today = moment();
  const dateMoment = moment(date);

  return today.isBefore(dateMoment);
};

const msToRefetchInvitations = () => {
  const env = getEnvironment();

  return env === PROD ? 3600000 : 60000;
};

const mustFetchInvitations = (timestamp?: number) =>
  timestamp ? Date.now() > timestamp + msToRefetchInvitations() : true;

export {
  calculateExpirationTime,
  isExpired,
  parseToLongDate,
  parseDate,
  parseDateQuery,
  getDate,
  getIsoDateWithTime,
  getRedemptionIsoDate,
  formatDate,
  isSameDay,
  getDiffDaysBetweenDateAndToday,
  getFullSpelledDate,
  parseRequestNodeFromObject,
  parseExpirationNodeFromObject,
  mustRedirectIfInCampaign,
  mustFetchInvitations,
  isFutureDate,
};
